import React, { useMemo } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';
import PageNamePlugin from './plugins/page-name';
import { jsx as _jsx } from "react/jsx-runtime";
export const SegmentContext = /*#__PURE__*/React.createContext(null);
SegmentContext.displayName = 'SegmentContext';
export const SegmentProvider = _ref => {
  let {
    writeKey,
    cdnURL,
    children
  } = _ref;
  const segment = useMemo(() => {
    if (!writeKey) {
      return null;
    }
    return AnalyticsBrowser.load({
      writeKey,
      cdnURL: cdnURL || undefined,
      plugins: [PageNamePlugin]
    }, {
      obfuscate: true,
      retryQueue: true
    });
  }, [writeKey, cdnURL]);
  return /*#__PURE__*/_jsx(SegmentContext.Provider, {
    value: segment,
    children: children
  });
};
export function useSegment() {
  return React.useContext(SegmentContext);
}